import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Select from "react-select";

import Utils from "../../utils";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

import ConfigDB from "../../config";

import { useTranslation } from "react-i18next";
import {
  createTask,
  createTaskChat,
  deleteTasksUser,
  getActionTypeSerach,
  getContactTypeSerach,
  getSearchTaskPartsList,
  getSearchTaskVehicleList,
  getSendCustomerMessage,
  getTaskChatList,
  getTasksDetails,
  updateTask,
} from "../../services/TaskServices";

import { getCommonSearchList } from "../../services/settingsServices";
import {
  createClientProfile,
  getSerachClientProfile,
  getSerachUserProfile,
  updateClientProfile,
} from "../../services/ClientProfileServices";
import {
  getPartsInventoryList,
  getReservesPartPendingList,
  getwarHouseEntityList,
} from "../../services/PartsInventory";
import ReactPaginate from "react-paginate";
import {
  getvehicleMakeAllList,
  getvehicleYearList,
} from "../../services/VehicleService";
import { getVehicleAllModalSerachList } from "../../services/VehicleModelService";
import { getVehicleSerachVariantList } from "../../services/VehicleVariantsService";
import { Range } from "react-range";
import {
  actionCityList,
  actionCountryList,
  actionStateList,
} from "../../services/CommonService";
import { getAllVehicleSerachType } from "../../services/VehicleMakeService";

const AddTask = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const { uuid } = useParams();

  const [taskAddData, setTaskAddData] = useState({
    id: "",
    tasks_name: "",
    task_type: 1,
    action_type_id: "",
    tasks_action: "",
    tasks_notes: "",
    tasks_priority: "",
    client_id: "",
    is_customer_support: "0",
    customer_name: "",
    indicative_phone_number: "",
    whatsapp_number: "",
    phone_number: "",
    email: "",
    customer_notes: "",
    contact_type_id: "",
    open_for_all_user: "0",
    client_name: "",
    client_country_code: "",
    client_district: "",
    client_city: "",
    client_bill_address: "",
    client_postal_code: "",
    client_shipping_addresses: "",
    client_vat_country_code: "",
    client_vat_number: "",
    client_vat_percentage: "",
    client_is_vat_exempt: "",
    client_indicative_phone_code: "",
    client_phone_number: "",
    client_whatsapp_number: "",
    client_email: "",
    user_list: [],
    vehicle_list: [],
    part_list: [],
    vehicle_list_id: "",
    tasks_status: "",
  });

  const [btnLoader, setBtnLoader] = useState(false);
  const [filterData, setFilterData] = useState({
    vehicle_year: "",
    make_id: "",
    variants_id: "",
    vehicle_model_id: "",
    vehicle_type: "",
    search: "",
    internal_id: "",
  });

  const [filterPartData, setFilterPartData] = useState({
    internal_id: "",
    search: "",
  });

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    search: "",
    is_reload: false,
    internal_id: "",
  });

  const MIN = 0;
  const MAX = 5;

  const [actionTypeList, setActionTypeList] = useState([]);
  const [contactTypeList, setContactTypeList] = useState([]);
  const [taskTypeList, setTaskTypeList] = useState([]);
  const [clientDataList, setClientDataList] = useState([]);
  const [modifyModal, setModifyModal] = useState(false);
  const [modifyAddClientModal, setModifyAddClientModal] = useState(false);

  const [clientProfileData, setclientProfileData] = useState({
    uuid: "",
    id: "",
    name: "",
    country_id: "",
    district: "",
    city: "",
    bill_address: "",
    postal_code: "",
    shipping_addresses: [],
    vat_country_code: "",
    vat_number: "",
    vat_percentage: 23,
    is_vat_exempt: "0",
    indicative_phone_code: "",
    phone_number: "",
    whatsapp_number: "",
    email: "",
    country_code: "",
  });

  const [clientAddProfileData, setClientAddProfileData] = useState({
    uuid: "",
    id: "",
    name: "",
    country_id: "",
    district: "",
    city: "",
    bill_address: "",
    postal_code: "",
    shipping_addresses: [],
    vat_country_code: "",
    vat_number: "",
    vat_percentage: 23,
    is_vat_exempt: "0",
    indicative_phone_code: "",
    phone_number: "",
    whatsapp_number: "",
    email: "",
    country_code: "",
  });

  let errorsObj = {
    tasks_name: "",
    name: "",
    country_id: "",
    district: "",
    city: "",
    bill_address: "",
    postal_code: "",
    shipping_addresses: [""],
    vat_country_code: "",
    vat_number: "",
    vat_percentage: "",
    is_vat_exempt: "",
    indicative_phone_code: "",
    phone_number: "",
    whatsapp_number: "",
    email: "",
  };
  const [errors, setErrors] = useState(errorsObj);

  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [userDataList, setUserDataList] = useState([]);
  const [vehicleModelAllList, setVehicleModelAllList] = useState([]);
  const [partModelAllList, setPartModelAllList] = useState([]);

  const [selectedVehicle, setSelectedVehicle] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [vehicleNote, setVehicleNote] = useState("");

  const [partsInventoryList, setPartsInventoryList] = useState([]);
  const [addedLers, setAddedLers] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [reservesPenList, setReservesPenList] = useState([]);

  const [priceValue, setPriceValue] = useState([1]);
  const [VehicleTypeList, setVehicleTypeList] = useState([]);
  const [VehicleYearList, setVehicleYearList] = useState([]);
  const [inputSelctedeYearValue, setInputSelctedYearValue] = useState("");
  const [VehicleMakeList, setVehicleMakeList] = useState([]);
  const [inputSelctedeMakeValue, setInputSelctedMakeValue] = useState("");
  const [VehicleModalList, setVehicleModalList] = useState([]);
  const [inputSelctedeModalValue, setInputSelctedModalValue] = useState("");
  const [VehicleVariantList, setVehicleVariantList] = useState([]);
  const [inputSelctededVariantValue, setInputSelctedVariantValue] =
    useState("");
  const [modifyqtyModal, setmodifyqtyModal] = useState(false);
  const [partqtyDetails, setPartqtyDetails] = useState("");

  const [selectedPrices, setSelectedPrices] = useState({});

  const [selectedEntities, setSelectedEntities] = useState({});

  const [entityList, setEntityList] = useState([]);
  const [selectedParts, setSelectedParts] = useState([]);

  const [unselectedParts, setUnselectedParts] = useState([]);
  const [resOrderData, setResOrderData] = useState({
    reservation_order_notes: "",
  });

  const [taskDetails, setTaskDetails] = useState("");

  const [taskStatusList, setTaskStatusList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([
    { type: "visitor", text: "Can you let me talk to the support?" },
    { type: "operator", text: "Sure!" },
    { type: "visitor", text: "Need your help, I need a developer in my site." },
    {
      type: "operator",
      text: "Hi... What is it? I'm a front-end developer, yay!",
      name: "Support Agent",
      timestamp: new Date().toLocaleTimeString(),
    },
  ]);
  const [chatMessagesList, setChatMessagesList] = useState([]);
  const [file, setFile] = useState(null);
  const [delModal, setDelModal] = useState(false);
  const [delpart, setDelPart] = useState("");
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [clientData, setClientData] = useState("");
  const [stateMainList, setStateMainList] = useState([]);
  const [cityMainList, setCityMainList] = useState([]);
  const [selectedChats, setSelectedChats] = useState([]);
  const [isSending, setIsSending] = useState(false);

  const onDeleteModalClose = () => {
    setDelModal(false);
  };

  const toggleChat = () => setIsOpen(!isOpen);

  const sendMessage = () => {
    if (!input.trim()) return;

    const newMessage = {
      type: "visitor",
      text: input,
      timestamp: new Date().toLocaleTimeString(),
    };

    setMessages([...messages, newMessage]);
    setInput("");
  };

  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chatMessagesList]);

  const fileInputRef = useRef(null);

  const handleFileClick = () => {
    fileInputRef.current?.click();
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
      handleSubmitChatTask(null, file);
      e.target.value = null;
    }
  };

  const handleSubmitChatTask = (e, selectedFile) => {
    if (e) e.preventDefault();

    const formData = new FormData();
    formData.append("tasks_id", taskDetails.id);
    formData.append("user_id", companyId?.id);
    formData.append("message", input);
    formData.append("files", selectedFile || file);

    createTaskChat(formData)
      .then((response) => {
        setInput("");
        setFile(null); // clear file after sending

        let data = {
          limit: tableLengthList[0],
          search: "",
          is_reload: false,
          tasks_id: taskDetails?.id,
        };
        return getTaskChatList(data);
      })
      .then((response) => {
        setChatMessagesList(response.data.data);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsModifyButtonLoad(false);
      });
  };

  const sortedMessagesAsc = chatMessagesList.sort((a, b) => {
    const parseDate = (str) => {
      const [datePart, timePart] = str.split(" ");
      const [day, month, year] = datePart.split("-");
      return new Date(year, month - 1, day, ...timePart.split(":"));
    };

    return parseDate(a.created_at) - parseDate(b.created_at);
  });

  const handleAddModal = (item) => {
    setclientProfileData({
      ...clientProfileData,
      uuid: item?.uuid,
      id: item?.id,
      name: item?.name,
      country_id: item?.country_id,
      district: item?.district,
      city: item?.city,
      bill_address: item?.bill_address,
      postal_code: item?.postal_code,
      shipping_addresses: item?.shipping_addresses,
      vat_country_code: item?.vat_country_code,
      vat_number: item?.vat_number,
      vat_percentage: item?.vat_percentage,
      is_vat_exempt: item?.is_vat_exempt,
      indicative_phone_code: item?.indicative_phone_code,
      phone_number: item?.phone_number,
      whatsapp_number: item?.whatsapp_number,
      email: item?.email,
      country_code: item?.country_code,
    });

    setModifyModal(true);
  };

  const fetchChatMessages = () => {
    getTaskChatList({
      limit: 50,
      search: "",
      is_reload: false,
      tasks_id: taskDetails?.id,
    })
      .then((response) => {
        setChatMessagesList(response.data.data);
      })
      .catch((err) => {
        console.error("Failed to fetch chat messages:", err);
      });
  };

  useEffect(() => {
    if (taskDetails?.id) {
      fetchChatMessages();
    }
  }, [taskDetails]);

  useEffect(() => {
    if (clientDataList && taskAddData?.client_id) {
      const foundClient = clientDataList.find(
        (item) => item.value == taskAddData.client_id
      )?.fullData;
      setclientProfileData({
        uuid: foundClient?.uuid,
        id: foundClient?.id,
        name: foundClient?.name,
        country_id: foundClient?.country_id,
        district: foundClient?.district,
        city: foundClient?.city,
        bill_address: foundClient?.bill_address,
        postal_code: foundClient?.postal_code,
        shipping_addresses: foundClient?.shipping_addresses,
        vat_country_code: foundClient?.vat_country_code,
        vat_number: foundClient?.vat_number,
        vat_percentage: foundClient?.vat_percentage,
        is_vat_exempt: foundClient?.is_vat_exempt,
        indicative_phone_code: foundClient?.indicative_phone_code,
        phone_number: foundClient?.phone_number,
        whatsapp_number: foundClient?.whatsapp_number,
        email: foundClient?.email,
        country_code: foundClient?.country_code,
      });
    }
  }, [clientDataList, taskAddData?.client_id]);

  useEffect(function () {
    actionCountryList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }
        setCountryList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (clientProfileData?.country_id) {
      actionStateList({ country_id: clientProfileData?.country_id })
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].name,
            });
          }
          setStateList(list);
        })
        .catch((err) => {});
    }
  }, [clientProfileData]);

  useEffect(() => {
    if (clientProfileData?.district) {
      actionCityList({ state_id: clientProfileData?.district })
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].name,
            });
          }
          setCityList(list);
        })
        .catch((err) => {});
    }
  }, [clientProfileData]);

  useEffect(() => {
    if (clientAddProfileData?.country_id) {
      actionStateList({ country_id: clientAddProfileData?.country_id })
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].name,
            });
          }
          setStateMainList(list);
        })
        .catch((err) => {});
    }
  }, [clientAddProfileData]);

  useEffect(() => {
    if (clientAddProfileData?.district) {
      actionCityList({ state_id: clientAddProfileData?.district })
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].name,
            });
          }
          setCityMainList(list);
        })
        .catch((err) => {});
    }
  }, [clientAddProfileData]);

  useEffect(() => {
    if (taskDetails) {
      setTaskAddData({
        ...taskAddData,
        id: taskDetails?.id,
        tasks_name: taskDetails?.tasks_name,
        task_type: taskDetails?.task_type,
        action_type_id: taskDetails?.action_type_id,
        tasks_action: taskDetails?.tasks_action,
        tasks_notes: taskDetails?.tasks_notes,
        tasks_priority: taskDetails?.tasks_priority,
        client_id: taskDetails?.client_id,
        is_customer_support: String(taskDetails?.is_customer_support),
        customer_name: taskDetails?.customer_name,
        indicative_phone_number: taskDetails?.indicative_phone_number,
        whatsapp_number: taskDetails?.whatsapp_number,
        phone_number: taskDetails?.phone_number,
        email: taskDetails?.email,
        customer_notes: taskDetails?.customer_notes,
        contact_type_id: taskDetails?.contact_type_id,
        open_for_all_user: String(taskDetails?.open_for_all_user),
        user_list: taskDetails?.user_list,
        tasks_status: taskDetails?.tasks_status,
        part_list: taskDetails?.part_list,
      });
      setSelectedVehicle(taskDetails?.vehicle_list);
      setPriceValue([taskDetails?.tasks_priority]);
      setVehicleNote(taskDetails?.task_order_list);
      setSelectedUser(taskDetails?.user_list);

      setclientProfileData({
        ...clientProfileData,
        name: taskDetails?.client_name,
        country_id: taskDetails?.client_country_id,
        district: taskDetails?.client_district_id,
        city: taskDetails?.client_city_id,
        bill_address: taskDetails?.client_bill_address,
        postal_code: taskDetails?.client_postal_code,
        shipping_addresses: taskDetails?.client_shipping_addresses,
        vat_country_code: taskDetails?.client_vat_country_code,
        vat_number: taskDetails?.client_vat_number,
        vat_percentage: taskDetails?.client_vat_percentage,
        is_vat_exempt: taskDetails?.client_is_vat_exempt,
        indicative_phone_code: taskDetails?.client_indicative_phone_code,
        phone_number: taskDetails?.client_phone_number,
        whatsapp_number: taskDetails?.client_phone_number,
        email: taskDetails?.client_email,
        country_code: taskDetails?.client_country_code,
      });
    }
  }, [taskDetails]);

  useEffect(() => {
    if (Array.isArray(taskAddData?.part_list)) {
      const preSelectedParts = [];
      const preSelectedPrices = {};
      const preSelectedEntities = {};
      const preReservationNotes = {};

      taskAddData?.part_list?.forEach((part) => {
        part.tasks_order_list?.forEach((item) => {
          const matchedPart = part.part_qty_list?.find(
            (p) => Number(p.id) === Number(item.part_qty_label_id)
          );

          if (matchedPart) {
            preSelectedParts.push(matchedPart);
            preSelectedPrices[matchedPart.id] = item.tasks_sales_price;
            preSelectedEntities[matchedPart.id] = item.location_id;
            preReservationNotes[matchedPart.id] =
              item.tasks_details_notes || "";
          }
        });
      });

      setSelectedParts(preSelectedParts);
      setSelectedPrices(preSelectedPrices);
      setSelectedEntities(preSelectedEntities);
      setResOrderData((prev) => ({
        ...prev,
        reservation_order_notes: preReservationNotes,
      }));
    }
  }, [taskAddData]);

  const handleCloseModal = () => {
    setModifyModal(false);

    setclientProfileData({
      uuid: "",
      id: "",
      name: "",
      country_id: "",
      district: "",
      city: "",
      bill_address: "",
      postal_code: "",
      shipping_addresses: [""],
      vat_country_code: "",
      vat_number: "",
      vat_percentage: 23,
      is_vat_exempt: "0",
      indicative_phone_code: "",
      phone_number: "",
      whatsapp_number: "",
      email: "",
      country_code: "",
    });
  };

  const handleCloseAddClientModal = () => {
    setModifyAddClientModal(false);

    setclientProfileData({
      uuid: "",
      id: "",
      name: "",
      country_id: "",
      district: "",
      city: "",
      bill_address: "",
      postal_code: "",
      shipping_addresses: [""],
      vat_country_code: "",
      vat_number: "",
      vat_percentage: 23,
      is_vat_exempt: "0",
      indicative_phone_code: "",
      phone_number: "",
      whatsapp_number: "",
      email: "",
      country_code: "",
    });
  };

  const handleOpenAddClientModal = () => {
    setModifyAddClientModal(true);
  };

  const handleSaveDataModal = () => {
    setModifyModal(false);
  };

  const renderOptions = (nodes, level = 0) => {
    return nodes?.map((node) => {
      if (node.children && node.children.length > 0) {
        return (
          <>
            <optgroup
              label={"\u00A0\u00A0".repeat(level) + node.warehouse_name}
              key={node.id}
            />
            {renderOptions(node.children, level + 1)}
          </>
        );
      } else {
        return (
          <option value={node.id} key={node.id}>
            {"\u00A0\u00A0".repeat(level) + node.warehouse_name}
          </option>
        );
      }
    });
  };

  const handleQtyOpen = (e, item) => {
    setPartqtyDetails(item);
    setmodifyqtyModal(true);
  };

  const handleQtyClose = () => {
    setmodifyqtyModal(false);
  };

  const handleQtyCloseFinal = () => {
    if (!selectedParts || selectedParts.length === 0) {
      toast.error(t("at_least_one_quantity_required"));
      return;
    }

    setmodifyqtyModal(false);
  };

  const handleSelectChange = (event, item) => {
    const value = event.target.value;

    setSelectedEntities((prevState) => ({
      ...prevState,
      [item.id]: value,
    }));
  };

  useEffect(() => {
    let data = { ...params };
    getwarHouseEntityList(data)
      .then((response) => {
        setEntityList(response.data.data);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, [params]);

  useEffect(() => {
    if (uuid) {
      let data = {
        id: uuid,
      };

      getTasksDetails(data)
        .then((response) => {
          setTaskDetails(response.data.data);
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  }, [uuid]);

  const handleManualInput = (partId, value) => {
    setSelectedPrices((prev) => ({
      ...prev,
      [partId]: value,
    }));
  };

  const handleCheckboxChangeTask = (partsId, id) => {
    setSelectedParts((prevSelected) => {
      const isAlreadySelected = prevSelected.some(
        (item) => Number(item.id) === Number(id)
      );

      if (isAlreadySelected) {
        const updatedSelected = prevSelected.filter(
          (item) => Number(item.id) !== Number(id)
        );

        const uncheckedParts = Array.isArray(partqtyDetails?.tasks_order_list)
          ? partqtyDetails.tasks_order_list.filter(
              (item) => Number(item.part_qty_label_id) === Number(id)
            )
          : [];

        setUnselectedParts((prevUnselected) => [
          ...prevUnselected,
          ...uncheckedParts,
        ]);

        return updatedSelected;
      } else {
        setUnselectedParts((prevUnselected) =>
          prevUnselected.filter(
            (item) => Number(item.part_qty_label_id) !== Number(id)
          )
        );

        return [...prevSelected, { parts_id: partsId, id }];
      }
    });
  };

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1;
    }

    setParams(paramsObj);
  };

  useEffect(function () {
    const obj = {
      search: "",
      limit: 20,
      page: 1,
    };
    getActionTypeSerach(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setActionTypeList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    const obj = {
      search: "",
      limit: 20,
      page: 1,
    };
    getContactTypeSerach(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setContactTypeList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "task_type",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTaskTypeList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "task_status",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTaskStatusList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    const obj = {
      search: "",
      limit: 20,
      page: 1,
    };
    getSerachClientProfile(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
            fullData: response.data[i],
          });
        }

        setClientDataList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    const obj = {
      search: "",
      limit: 20,
      page: 1,
    };
    getSerachUserProfile(obj)
      .then((response) => {
        const filteredData = response?.data?.data?.filter(
          (user) => user?.id !== companyId?.id
        );
        setUserDataList(filteredData);
      })
      .catch(() => {});
  }, []);

  useEffect(
    function () {
      var obj = {
        limit: 30,
        page: 1,
        internal_id: filterData?.internal_id ? filterData?.internal_id : "",
        vehicle_type: filterData?.vehicle_type ? filterData?.vehicle_type : "",
        vehicle_year: filterData?.vehicle_year ? filterData?.vehicle_year : "",
        make_id: filterData?.make_id ? filterData?.make_id : "",
        vehicle_model_id: filterData?.vehicle_model_id
          ? filterData?.vehicle_model_id
          : "",
        variants_id: filterData?.variants_id ? filterData?.variants_id : "",
        search: filterData?.search ? filterData?.search : "",
      };

      getSearchTaskVehicleList(obj)
        .then((response) => {
          setVehicleModelAllList(response.data.data);
        })
        .catch((err) => {});
    },
    [filterData]
  );
  useEffect(
    function () {
      var obj = {
        limit: 30,
        page: 1,
        internal_id: filterPartData?.internal_id
          ? filterPartData?.internal_id
          : "",
        search: filterPartData?.search ? filterPartData?.search : "",
      };
      getSearchTaskPartsList(obj)
        .then((response) => {
          setPartModelAllList(response.data.data);
        })
        .catch((err) => {});
    },
    [filterPartData]
  );

  useEffect(function () {
    let obj = {
      serach: "",
      limit: 20,
      page: 1,
    };

    getAllVehicleSerachType(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].vehicle_type_name,
          });
        }
        setVehicleTypeList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: params.page,
      search: "",
      is_reload: true,
    };
    getvehicleYearList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i],
            label: response.data[i],
          });
        }
        setVehicleYearList(list);
      })
      .catch((err) => {});
  }, []);

  const handleInputSelectedChangeYearList = (inputSelctedeYearValue) => {
    setInputSelctedYearValue(inputSelctedeYearValue);
    const obj = {
      search: inputSelctedeYearValue,
      limit: 20,
      page: 1,
    };

    getvehicleYearList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i],
            label: response.data[i],
          });
        }
        setVehicleYearList(list);
      })
      .catch((err) => {});
  };

  useEffect(
    function () {
      // if (filterData?.vehicle_year) {
      let data = {
        limit: 20,
        page: params.page,
        search: "",
        year: filterData?.vehicle_year ? filterData?.vehicle_year : "",
        vehicle_type_id: filterData?.vehicle_type
          ? filterData?.vehicle_type
          : "",
        is_reload: true,
        is_Filter: 1,
      };
      getvehicleMakeAllList(data)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i]?.id,
              label: response.data[i]?.description,
            });
          }
          setVehicleMakeList(list);
        })
        .catch((err) => {});
    },
    // },
    [filterData]
  );

  const handleInputSelectedChangeMakeList = (inputSelctedeMakeValue) => {
    setInputSelctedMakeValue(inputSelctedeMakeValue);
    if (inputSelctedeMakeValue.length > 0) {
      const obj = {
        limit: 20,
        page: params.page,
        search: inputSelctedeMakeValue,
        year: filterData?.vehicle_year,
        vehicle_type_id: filterData?.vehicle_type,
        is_Filter: 1,

        is_reload: true,
      };

      getvehicleMakeAllList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i]?.id,
              label: response.data[i]?.description,
            });
          }
          setVehicleMakeList(list);
        })
        .catch((err) => {});
    }
  };

  useEffect(
    function () {
      if (filterData?.make_id) {
        let data = {
          limit: 20,
          page: params.page,
          search: "",
          vehicle_year: filterData?.vehicle_year,
          make_id: filterData?.make_id,
          vehicle_type_id: filterData?.vehicle_type,

          is_reload: true,
        };

        getVehicleAllModalSerachList(data)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i]?.id,
                label: response.data[i]?.model_name,
              });
            }
            setVehicleModalList(list);
          })
          .catch((err) => {});
      }
    },
    [filterData?.make_id]
  );

  const handleInputSelectedChangeModalList = (inputSelctedeModalValue) => {
    setInputSelctedModalValue(inputSelctedeModalValue);
    if (inputSelctedeModalValue.length > 0) {
      const obj = {
        limit: 20,
        page: params.page,
        search: inputSelctedeModalValue,
        make_id: filterData?.make_id,
        vehicle_year: filterData?.vehicle_year,
        vehicle_type_id: filterData?.vehicle_type,

        is_reload: true,
      };

      getVehicleAllModalSerachList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i]?.id,
              label: response.data[i]?.model_name,
            });
          }
          setVehicleModalList(list);
        })
        .catch((err) => {});
    }
  };

  useEffect(
    function () {
      if (filterData?.vehicle_model_id) {
        let data = {
          limit: 20,
          page: params.page,
          search: "",
          vehicle_year: filterData?.vehicle_year,
          vehicle_model_id: filterData.vehicle_model_id,
          vehicle_type_id: filterData?.vehicle_type,

          is_reload: true,
        };
        getVehicleSerachVariantList(data)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i]?.id,
                label: response.data[i]?.variants_name,
              });
            }
            setVehicleVariantList(list);
          })
          .catch((err) => {});
      }
    },
    [filterData?.vehicle_model_id]
  );

  const handleInputSelectedChangeVariantList = (inputSelctededVariantValue) => {
    setInputSelctedVariantValue(inputSelctededVariantValue);
    if (inputSelctededVariantValue.length > 0) {
      const obj = {
        limit: 20,
        page: params.page,
        search: inputSelctededVariantValue,
        vehicle_year: filterData?.vehicle_year,
        vehicle_model_id: filterData.vehicle_model_id,
        vehicle_type_id: filterData?.vehicle_type,

        is_reload: true,
      };

      getVehicleSerachVariantList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i]?.id,
              label: response.data[i]?.variants_name,
            });
          }
          setVehicleVariantList(list);
        })
        .catch((err) => {});
    }
  };

  // useEffect(() => {
  //   let data = { ...params };
  //   getPartsInventoryList(data)
  //     .then((response) => {
  //       setPartsInventoryList(response.data.data);
  //       setTotalRecords(response.data.total);
  //     })
  //     .catch((err) => {
  //       toast.error(Utils.getErrorMessage(err));
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // }, [params]);

  useEffect(() => {
    let partId = addedLers?.map((x) => x.id);
    if (partId?.length > 0) {
      let data = {
        parts_id: partId,
        reservation_id: "",
        limit: tableLengthList[0],
        page: 1,
        search: "",
        is_reload: false,
        company_id: companyId.company_id || 0,
        is_update: true,
      };
      getReservesPartPendingList(data)
        .then((response) => {
          setReservesPenList(response.data.data);
          setTotalRecords(response.data.total);
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [addedLers]);

  const handleCheckboxChange = (e) => {
    setTaskAddData({
      ...taskAddData,
      is_customer_support: e.target.checked ? "1" : "0",
    });
  };

  const handleCheckboxClientVatChange = (e) => {
    setclientProfileData({
      ...clientProfileData,
      is_vat_exempt: e.target.checked ? "1" : "0",
    });
  };

  const handleCheckboxAddClientVatChange = (e) => {
    setClientAddProfileData({
      ...clientAddProfileData,
      is_vat_exempt: e.target.checked ? "1" : "0",
    });
  };

  const handleCheckboxOpenChange = (e) => {
    setTaskAddData({
      ...taskAddData,
      open_for_all_user: e.target.checked ? "1" : "0",
    });
  };

  const handleAddressChange = (index, value) => {
    const addresses = Array.isArray(clientProfileData.shipping_addresses)
      ? clientProfileData.shipping_addresses
      : [];

    const updatedAddresses = [...addresses];
    updatedAddresses[index] = value;

    setclientProfileData({
      ...clientProfileData,
      shipping_addresses: updatedAddresses,
    });
  };

  const handleAddAddress = () => {
    const addresses = Array.isArray(clientProfileData.shipping_addresses)
      ? clientProfileData.shipping_addresses
      : [];

    setclientProfileData({
      ...clientProfileData,
      shipping_addresses: [...addresses, ""],
    });
  };

  const handleRemoveAddress = (index) => {
    const addresses = Array.isArray(clientProfileData.shipping_addresses)
      ? clientProfileData.shipping_addresses
      : [];

    const updatedAddresses = [...addresses];
    updatedAddresses.splice(index, 1);

    setclientProfileData({
      ...clientProfileData,
      shipping_addresses: updatedAddresses,
    });
  };

  const handleAddressChangeMainClient = (index, value) => {
    const addresses = Array.isArray(clientAddProfileData.shipping_addresses)
      ? clientAddProfileData.shipping_addresses
      : [];

    const updatedAddresses = [...addresses];
    updatedAddresses[index] = value;

    setClientAddProfileData({
      ...clientAddProfileData,
      shipping_addresses: updatedAddresses,
    });
  };

  const handleAddAddressMainClient = () => {
    const addresses = Array.isArray(clientAddProfileData.shipping_addresses)
      ? clientAddProfileData.shipping_addresses
      : [];

    setClientAddProfileData({
      ...clientAddProfileData,
      shipping_addresses: [...addresses, ""],
    });
  };

  const handleRemoveAddressMainClient = (index) => {
    const addresses = Array.isArray(clientAddProfileData.shipping_addresses)
      ? clientAddProfileData.shipping_addresses
      : [];

    const updatedAddresses = [...addresses];
    updatedAddresses.splice(index, 1);

    setClientAddProfileData({
      ...clientAddProfileData,
      shipping_addresses: updatedAddresses,
    });
  };

  useEffect(() => {
    if (taskDetails) {
      const updatedSelectedVehicles = taskDetails?.task_order_list?.map(
        (order) => {
          const matchedVehicle = taskDetails?.vehicle_list.find(
            (v) => v.id === Number(order.vehicle_id)
          );

          return {
            vehicle_id: order.vehicle_id,
            vehicle_name: matchedVehicle
              ? `${matchedVehicle.vehicle_year || ""} | ${
                  matchedVehicle.vehicle_make_name || ""
                } | ${matchedVehicle.vehicle_model || ""} | ${
                  matchedVehicle.vehicle_variant_name || ""
                } | ${matchedVehicle.vehicle_internal_id || ""}`
              : "Unknown Vehicle",
            tasks_details_notes: order.tasks_details_notes || "",
          };
        }
      );

      setSelectedVehicle(updatedSelectedVehicles);
    }
  }, [taskDetails]);

  const handleAddVehicle = (vehicle, note) => {
    const isAlreadyAdded = selectedVehicle.some(
      (v) => v.vehicle_id === vehicle.id
    );

    if (isAlreadyAdded) {
      setSelectedVehicle((prev) =>
        prev.filter((v) => v.vehicle_id !== vehicle.id)
      );

      setVehicleNote((prevNotes) => {
        const updatedNotes = { ...prevNotes };
        delete updatedNotes[vehicle.id];
        return updatedNotes;
      });
    } else {
      if (!note) {
        toast.error(t("please_enter_task_note"));
        return;
      }

      setSelectedVehicle((prev) => [
        ...prev,
        {
          vehicle_id: vehicle.id,
          vehicle_name: `${vehicle.vehicle_year || ""} | ${
            vehicle.vehicle_make_name || ""
          } | ${vehicle.vehicle_model || ""} | ${
            vehicle.vehicle_variant_name || ""
          } | ${vehicle.vehicle_internal_id || ""}`,
          tasks_details_notes: note,
        },
      ]);
    }
  };

  const handleAddUser = (user) => {
    const isAlreadyAdded = selectedUser.some(
      (v) => v.user_id === user.user_id || v.user_id === user.id
    );
    if (isAlreadyAdded) {
    } else {
      setSelectedUser((prev) => [
        ...prev,
        {
          name: user.name,
          user_id: user.user_id ? user.user_id : user.id,
          id: user.id || null,
        },
      ]);
    }
  };

  const handleRemoveUser = (user) => {
    if (uuid) {
      setDelPart(user);
      setDelModal(true);
    } else {
      setSelectedUser((prev) => prev.filter((v) => v.user_id !== user.user_id));
    }
  };

  // const handleAddPart = (vehicle) => {
  //   const isAlreadyAdded = selectedPart.some((v) => v.id === vehicle.id);

  //   if (isAlreadyAdded) {
  //     setSelectedPart((prev) => prev.filter((v) => v.id !== vehicle.id));
  //   } else {
  //     setSelectedPart((prev) => [
  //       ...prev,
  //       {
  //         part: vehicle,
  //         id: vehicle.id,
  //         part_name: `${vehicle.part_name || ""} || ${
  //           vehicle.vehicle_year || ""
  //         } | ${vehicle.vehicle_make_name || ""} | ${
  //           vehicle.vehicle_model || ""
  //         } | ${vehicle.vehicle_variant_name || ""} | ${
  //           vehicle.parts_internal_id || ""
  //         }`,
  //         part_qty_list: vehicle.part_qty_list,
  //       },
  //     ]);
  //   }
  // };

  const handleAddPart = (vehicle) => {
    const isAlreadyAdded = taskAddData.part_list.some(
      (v) => v.id === vehicle.id
    );

    if (isAlreadyAdded) {
      const updatedList = taskAddData.part_list.filter(
        (v) => v.id !== vehicle.id
      );

      setTaskAddData((prev) => ({
        ...prev,
        part_list: updatedList,
        vehicle_list_id:
          updatedList.length > 0 ? updatedList[0].vehicle_list_id : "",
      }));
    } else {
      const newVehicle = {
        part: vehicle,
        id: vehicle.id,
        part_name: `${vehicle.namePartPT || ""} || ${
          vehicle.vehicle_year || ""
        } | ${vehicle.vehicle_make_name || ""} | ${
          vehicle.vehicle_model || ""
        } | ${vehicle.vehicle_variant_name || ""} | ${
          vehicle.parts_internal_id || ""
        }`,
        part_qty_list: vehicle.part_qty_list,
        vehicle_list_id: vehicle.vehicle_list_id,
      };

      setTaskAddData((prev) => ({
        ...prev,
        part_list: [...prev.part_list, newVehicle],
        vehicle_list_id: vehicle.vehicle_list_id,
      }));
    }
  };

  const handleSUbmitTask = (e) => {
    e.preventDefault();

    const partListData = [];

    selectedParts?.forEach((item) => {
      const partsId = item.parts_id;

      let partGroup = partListData.find((entry) => entry.parts_id === partsId);
      if (!partGroup) {
        partGroup = { parts_id: partsId, part_qty_list: [] };
        partListData.push(partGroup);
      }

      partGroup.part_qty_list.push({
        tasks_sales_price: selectedPrices[item.id] ?? 0,
        part_qty_id: item.id,
        location_id: selectedEntities[item?.id],
        tasks_details_notes:
          resOrderData.reservation_order_notes[item.id] || "",
      });
    });
    const nonEmptyGroups = partListData.filter(
      (group) => group.part_qty_list.length > 0
    );

    if (taskAddData?.task_type === 1) {
      if (nonEmptyGroups.length < 1) {
        toast.error(t("exactly_one_part_group_qty"));
        return;
      }
    }

    const originalUserId = taskDetails?.user_list?.map((x) => x.id) || [];

    const userList = selectedUser
      ?.filter((v) => !originalUserId.includes(v.id))
      .map((v) => ({
        user_id: v.user_id,
        status: 0,
      }));

    // const originalVehicleIds =
    //   taskDetails?.task_order_list?.map((v) => v.vehicle_id) || [];

    const vehicleList = selectedVehicle?.map((v) => ({
      tasks_details_notes: v.tasks_details_notes,
      vehicle_id: v.vehicle_id,
    }));

    let data = {
      tasks_name: taskAddData.tasks_name,
      task_type: taskAddData?.task_type,
      action_type_id: taskAddData?.action_type_id,
      tasks_action: taskAddData?.tasks_action,
      tasks_notes: taskAddData?.tasks_notes,
      tasks_priority: priceValue[0],
      client_id: taskAddData?.client_id ? taskAddData?.client_id : 0,
      is_customer_support: taskAddData?.is_customer_support,
      ...(taskAddData?.is_customer_support === "1" && {
        customer_name: taskAddData?.customer_name,
        indicative_phone_number: taskAddData?.indicative_phone_number,
        whatsapp_number: taskAddData?.whatsapp_number,
        phone_number: taskAddData?.phone_number,
        email: taskAddData?.email,
        customer_notes: taskAddData?.customer_notes,
        contact_type_id: taskAddData?.contact_type_id,
      }),

      client_name: clientProfileData?.name,
      client_country_code: clientProfileData?.country_code,
      client_bill_address: clientProfileData?.bill_address,
      client_postal_code: clientProfileData?.postal_code,
      client_shipping_addresses: clientProfileData?.shipping_addresses,
      client_vat_country_code: clientProfileData?.vat_country_code,
      client_vat_number: clientProfileData?.vat_number,
      client_vat_percentage: clientProfileData?.vat_percentage,
      client_is_vat_exempt: clientProfileData?.is_vat_exempt,
      client_indicative_phone_code: clientProfileData?.indicative_phone_code,
      client_phone_number: clientProfileData?.phone_number,
      client_whatsapp_number: clientProfileData?.whatsapp_number,
      client_email: clientProfileData?.email,
      client_country_id: clientProfileData?.country_id,
      client_district_id: clientProfileData?.district,
      client_city_id: clientProfileData?.city,
      open_for_all_user: taskAddData?.open_for_all_user,

      ...(taskAddData?.open_for_all_user === "0" && {
        user_list: userList,
      }),

      ...(taskAddData?.task_type === 2 && {
        vehicle_list: vehicleList,
      }),

      ...(taskAddData?.task_type === 1 && {
        part_list: partListData,
      }),
    };

    let updatedata = {
      id: taskDetails?.id,
      tasks_name: taskAddData.tasks_name,
      task_type: taskAddData?.task_type,
      action_type_id: taskAddData?.action_type_id,
      tasks_action: taskAddData?.tasks_action,
      tasks_notes: taskAddData?.tasks_notes,
      tasks_priority: priceValue[0],
      client_id: taskAddData?.client_id ? taskAddData?.client_id : 0,
      is_customer_support: taskAddData?.is_customer_support,
      ...(taskAddData?.is_customer_support === "1" && {
        customer_name: taskAddData?.customer_name,
        indicative_phone_number: taskAddData?.indicative_phone_number,
        whatsapp_number: taskAddData?.whatsapp_number,
        phone_number: taskAddData?.phone_number,
        email: taskAddData?.email,
        customer_notes: taskAddData?.customer_notes,
        contact_type_id: taskAddData?.contact_type_id,
      }),

      client_name: clientProfileData?.name,
      client_country_code: clientProfileData?.country_code,
      client_bill_address: clientProfileData?.bill_address,
      client_postal_code: clientProfileData?.postal_code,
      client_shipping_addresses: clientProfileData?.shipping_addresses,
      client_vat_country_code: clientProfileData?.vat_country_code,
      client_vat_number: clientProfileData?.vat_number,
      client_vat_percentage: clientProfileData?.vat_percentage,
      client_is_vat_exempt: clientProfileData?.is_vat_exempt,
      client_indicative_phone_code: clientProfileData?.indicative_phone_code,
      client_phone_number: clientProfileData?.phone_number,
      client_whatsapp_number: clientProfileData?.whatsapp_number,
      client_email: clientProfileData?.email,
      client_country_id: clientProfileData?.country_id,
      client_district_id: clientProfileData?.district,
      client_city_id: clientProfileData?.city,
      open_for_all_user: taskAddData?.open_for_all_user,

      ...(taskAddData?.open_for_all_user === "0" && {
        user_list: userList,
      }),

      ...(taskAddData?.task_type === 2 && {
        vehicle_list: vehicleList,
      }),

      ...(taskAddData?.task_type === 1 && {
        part_list: partListData,
      }),
      tasks_status: taskAddData?.tasks_status,
    };

    if (taskDetails?.id) {
      updateTask(updatedata)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/tasks");
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    } else {
      createTask(data)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/tasks");
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  };

  const onDestoryMainTask = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { id: delpart.id };
    deleteTasksUser(data)
      .then((response) => {
        toast.success(response.data.message);
        let data = {
          id: uuid,
        };

        getTasksDetails(data)
          .then((response) => {
            setTaskDetails(response.data.data);
          })
          .catch((err) => {
            toast.error(err.message);
          });
        setDelPart("");
        setDelModal(false);
        setIsDelButtonLoad(false);
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleAddClient = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };
    if (!clientAddProfileData.name) {
      errorObj.name = `Name is required.`;
      error = true;
    }

    if (!clientAddProfileData.country_code) {
      errorObj.country_code = `Country is required.`;
      error = true;
    }

    if (!clientAddProfileData.district) {
      errorObj.district = `State is required.`;
      error = true;
    }

    if (!clientAddProfileData.city) {
      errorObj.city = `City is required.`;
      error = true;
    }

    if (!clientAddProfileData.bill_address) {
      errorObj.bill_address = `Bill address is required.`;
      error = true;
    }

    if (!clientAddProfileData.postal_code) {
      errorObj.postal_code = `Postal code is required.`;
      error = true;
    }

    if (!clientAddProfileData.email) {
      errorObj.email = `Email is required.`;
      error = true;
    }

    setErrors(errorObj);
    Utils.focusError();
    if (error) return;

    setIsModifyButtonLoad(true);
    let data = {
      name: clientAddProfileData?.name,
      country_code: clientAddProfileData?.country_code,
      country_id: clientAddProfileData?.country_id,
      district: clientAddProfileData?.district,
      city: clientAddProfileData?.city,
      bill_address: clientAddProfileData?.bill_address,
      postal_code: clientAddProfileData?.postal_code,
      shipping_addresses: clientAddProfileData?.shipping_addresses,
      vat_country_code: clientAddProfileData?.vat_country_code,
      vat_number: clientAddProfileData?.vat_number,
      vat_percentage: clientAddProfileData?.vat_percentage,
      is_vat_exempt: clientAddProfileData?.is_vat_exempt,
      indicative_phone_code: clientAddProfileData?.indicative_phone_code,
      phone_number: clientAddProfileData?.phone_number,
      whatsapp_number: clientAddProfileData?.whatsapp_number,
      email: clientAddProfileData?.email,
    };

    createClientProfile(data)
      .then((response) => {
        toast.success(response.data.message);

        setModifyAddClientModal(false);
        setIsModifyButtonLoad(false);
        setClientData(response.data.data);

        setClientAddProfileData({
          uuid: "",
          id: "",
          name: "",
          country_id: "",
          country_code: "",
          district: "",
          city: "",
          bill_address: "",
          postal_code: "",
          shipping_addresses: [""],
          vat_country_code: "",
          vat_number: "",
          vat_percentage: "",
          is_vat_exempt: "",
          indicative_phone_code: "",
          phone_number: "",
          whatsapp_number: "",
          email: "",
        });
        setErrors({
          name: "",
          country_id: "",
          country_code: "",
          district: "",
          city: "",
          bill_address: "",
          postal_code: "",
          shipping_addresses: [""],
          vat_country_code: "",
          vat_number: "",
          vat_percentage: "",
          is_vat_exempt: "",
          indicative_phone_code: "",
          phone_number: "",
          whatsapp_number: "",
          email: "",
        });
        const obj = {
          search: "",
          limit: 20,
          page: 1,
        };

        return getSerachClientProfile(obj);
      })
      .then((response) => {
        response = response.data;
        let list = [];

        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
            fullData: response.data[i],
          });
        }

        setClientDataList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsModifyButtonLoad(false);
      });
  };

  const handleSendCustomerMessageWp = (e) => {
    e.preventDefault();
    setIsSending(true);

    const data = {
      chat_id: selectedChats,
      tasks_id: uuid,
    };

    getSendCustomerMessage(data)
      .then((response) => {
        toast.success(response.data.message);
        setSelectedChats([]);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2 px-2">
            <div className="col-sm-6">
              <h1>{uuid ? t("edit_task") : t("add_task")}</h1>
            </div>
            <div className="col-sm-6"></div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-primary">
                <Form method={`post`} onSubmit={handleSUbmitTask}>
                  <div className="card-body">
                    <div className="row justify-content-start">
                      <div className="col-md-4">
                        <FormGroup>
                          <Label className="col-form-label ml-2 Label-my form-label form-label">
                            {t("name")}
                          </Label>
                          <div className="col-xl-12">
                            <div className="input-div">
                              <input
                                className="form-control input-search"
                                type="text"
                                value={taskAddData.tasks_name}
                                onChange={(e) => {
                                  setTaskAddData({
                                    ...taskAddData,
                                    tasks_name: e.target.value,
                                  });
                                }}
                                name={`tasks_name`}
                                maxLength={100}
                                placeholder={t("name")}
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </div>
                      <div className="col-md-4">
                        <FormGroup>
                          <Label className="col-form-label ml-2 Label-my form-label form-label">
                            {t("task_type")}
                          </Label>
                          <div className="col-xl-12">
                            <div className="input-div">
                              <Select
                                className="my-Select"
                                options={taskTypeList}
                                value={taskTypeList.find(
                                  (option) =>
                                    option.value ===
                                    Number(taskAddData.task_type)
                                )}
                                onChange={(selectedOption) =>
                                  setTaskAddData({
                                    ...taskAddData,
                                    task_type: selectedOption.value,
                                  })
                                }
                                placeholder={"Select Task type"}
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </div>
                      <div className="col-md-4">
                        <FormGroup>
                          <Label className="col-form-label ml-2 Label-my form-label form-label">
                            {t("action_type")}
                          </Label>
                          <div className="col-xl-12">
                            <div className="input-div">
                              <Select
                                className="my-Select"
                                options={actionTypeList}
                                value={actionTypeList.find(
                                  (option) =>
                                    option.value ===
                                    Number(taskAddData.action_type_id)
                                )}
                                onChange={(selectedOption) =>
                                  setTaskAddData({
                                    ...taskAddData,
                                    action_type_id: selectedOption.value,
                                  })
                                }
                                placeholder={"Select Action type"}
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </div>

                      <div className="col-md-4">
                        <FormGroup>
                          <Label className="col-form-label ml-2 Label-my form-label form-label">
                            {t("task_action")}
                          </Label>
                          <div className="col-xl-12">
                            <div className="input-div">
                              <input
                                className="form-control input-search"
                                type="text"
                                value={taskAddData.tasks_action}
                                onChange={(e) => {
                                  setTaskAddData({
                                    ...taskAddData,
                                    tasks_action: e.target.value,
                                  });
                                }}
                                name={`tasks_action`}
                                maxLength={100}
                                placeholder={t("task_action")}
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </div>

                      <div className="col-md-4">
                        {/* <FormGroup>
                          <Label className="col-form-label ml-2 Label-my form-label form-label">
                            {t("task_action")}
                          </Label>
                          <div className="col-xl-12">
                            <div className="input-div">
                              <input
                                className="form-control input-search"
                                type="text"
                                value={taskAddData.tasks_action}
                                onChange={(e) => {
                                  setTaskAddData({
                                    ...taskAddData,
                                    tasks_action: e.target.value,
                                  });
                                }}
                                name={`tasks_action`}
                                maxLength={100}
                                placeholder={t("task_action")}
                              />
                            </div>
                            {errors.name && (
                              <span className="input-error">{errors.name}</span>
                            )}
                          </div>
                        </FormGroup> */}

                        <FormGroup>
                          <Label className="col-form-label ml-2 Label-my form-label form-label">
                            {t("priority")}
                          </Label>
                          <div className="col-xl-12">
                            <div className="input-div">
                              <Range
                                step={1}
                                min={MIN}
                                max={MAX}
                                values={priceValue}
                                onChange={(values) => setPriceValue(values)}
                                renderTrack={({ props, children }) => (
                                  <div
                                    {...props}
                                    style={{
                                      ...props.style,
                                      height: "6px",
                                      width: "100%",
                                      backgroundColor: "#ccc",
                                    }}
                                  >
                                    {children}
                                  </div>
                                )}
                                renderThumb={({ props }) => (
                                  <div
                                    {...props}
                                    style={{
                                      ...props.style,
                                      height: "25px",
                                      width: "25px",
                                      backgroundColor: "#999",
                                      marginTop: "1px",
                                      borderRadius: "100px",
                                    }}
                                  />
                                )}
                              />

                              <div style={{ marginTop: "0.5rem" }}>
                                {t("value")}: {priceValue[0]}
                              </div>
                            </div>
                          </div>
                        </FormGroup>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <FormGroup>
                          <Label className="col-form-label ml-2 Label-my form-label form-label">
                            {t("select_client")}
                          </Label>

                          <div className="row">
                            <div className="col-md-3">
                              <button
                                style={{
                                  fontSize: "20px",
                                  color: "#81bb42",
                                  cursor: "pointer",
                                  boxShadow: "none",
                                  background: "white",
                                  border: "none",
                                }}
                                type="button"
                                onClick={() => {
                                  const selectedClient = clientDataList.find(
                                    (item) =>
                                      item.value == taskAddData.client_id ||
                                      item.value === clientData.id
                                  )?.fullData;

                                  if (selectedClient) {
                                    handleAddModal(selectedClient);
                                  } else {
                                    const fallbackData = {
                                      uuid: "",
                                      id: "",
                                      name: taskDetails?.client_name || "",
                                      country_id:
                                        taskDetails?.client_country_id || "",
                                      district:
                                        taskDetails?.client_district_id || "",
                                      city: taskDetails?.client_city_id || "",
                                      bill_address:
                                        taskDetails?.client_bill_address || "",
                                      postal_code:
                                        taskDetails?.client_postal_code || "",
                                      shipping_addresses: Array.isArray(
                                        taskDetails?.client_shipping_addresses
                                      )
                                        ? taskDetails.client_shipping_addresses
                                        : [],
                                      vat_country_code:
                                        taskDetails?.client_vat_country_code ||
                                        "",
                                      vat_number:
                                        taskDetails?.client_vat_number || "",
                                      vat_percentage:
                                        taskDetails?.client_vat_percentage ||
                                        "",
                                      is_vat_exempt:
                                        String(
                                          taskDetails?.client_is_vat_exempt
                                        ) || "0",
                                      indicative_phone_code:
                                        taskDetails?.client_indicative_phone_code ||
                                        "",
                                      phone_number:
                                        taskDetails?.client_phone_number || "",
                                      whatsapp_number:
                                        taskDetails?.client_phone_number || "",
                                      email: taskDetails?.client_email || "",
                                      country_code:
                                        taskDetails?.client_country_code || "",
                                    };

                                    setclientProfileData(fallbackData);
                                    handleAddModal(fallbackData);
                                  }
                                }}
                              >
                                <i className="bi bi-info-circle-fill"></i>
                              </button>
                            </div>

                            <div
                              className="col-md-3"
                              style={{
                                marginBottom: "18px",
                              }}
                            >
                              <button
                                type="button"
                                className="btn btn-block btn-primary"
                                style={{ width: "125px", marginTop: "10px" }}
                                onClick={handleOpenAddClientModal}
                              >
                                {t("add_client")}{" "}
                                <i className="bi bi-check2"></i>
                              </button>
                            </div>

                            <div className="col-md-3"></div>
                            <div className="col-md-3"></div>
                          </div>
                          <div className="col-xl-12">
                            <div className="input-div">
                              <Select
                                className="my-select-v"
                                options={clientDataList}
                                value={
                                  clientDataList.find(
                                    (item) =>
                                      item.value == taskAddData.client_id ||
                                      item.value === clientData?.id
                                  ) || null
                                }
                                onChange={(selectedOption) => {
                                  setTaskAddData({
                                    ...taskAddData,
                                    client_id: selectedOption
                                      ? selectedOption.value
                                      : "",
                                  });
                                  setClientData(
                                    selectedOption ? selectedOption.value : ""
                                  );
                                }}
                                isSearchable={true}
                                isClearable={true}
                                placeholder={"Select Client"}
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </div>

                      <div className="col-md-6">
                        <FormGroup>
                          <Label className="col-form-label ml-2 Label-my form-label form-label">
                            {t("is_customer_support")}
                          </Label>
                          <div className="col-xl-12">
                            <div className="input-div">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={
                                    taskAddData.is_customer_support === "1"
                                  }
                                  onChange={handleCheckboxChange}
                                />
                                <label className="form-check-label">
                                  {t("is_customer_support")}
                                </label>
                              </div>
                            </div>
                          </div>
                        </FormGroup>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <FormGroup>
                          <Label className="col-form-label ml-2 Label-my form-label form-label">
                            {t("task_notes")}
                          </Label>
                          <div className="col-xl-12">
                            <div className="input-div">
                              <textarea
                                className="form-control input-search"
                                type="text"
                                value={taskAddData.tasks_notes}
                                onChange={(e) => {
                                  setTaskAddData({
                                    ...taskAddData,
                                    tasks_notes: e.target.value,
                                  });
                                }}
                                name={`tasks_notes`}
                                placeholder={t("task_notes")}
                                rows={3}
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </div>
                    </div>

                    {taskAddData?.is_customer_support === "1" && (
                      <>
                        <div className="row justify-content-start">
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("customer_name")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={taskAddData.customer_name}
                                    onChange={(e) => {
                                      setTaskAddData({
                                        ...taskAddData,
                                        customer_name: e.target.value,
                                      });
                                    }}
                                    name={`customer_name`}
                                    placeholder={t("customer_name")}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("indicative_phone_number")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={taskAddData.indicative_phone_number}
                                    onChange={(e) => {
                                      setTaskAddData({
                                        ...taskAddData,
                                        indicative_phone_number: e.target.value,
                                      });
                                    }}
                                    name={`indicative_phone_number`}
                                    maxLength={100}
                                    placeholder={t("indicative_phone_number")}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("whatsapp_number")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={taskAddData.whatsapp_number}
                                    onChange={(e) => {
                                      setTaskAddData({
                                        ...taskAddData,
                                        whatsapp_number: e.target.value,
                                      });
                                    }}
                                    name={`whatsapp_number`}
                                    placeholder={t("whatsapp_number")}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("phone_number")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={taskAddData.phone_number}
                                    onChange={(e) => {
                                      setTaskAddData({
                                        ...taskAddData,
                                        phone_number: e.target.value,
                                      });
                                    }}
                                    name={`phone_number`}
                                    placeholder={t("phone_number")}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("email")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={taskAddData.email}
                                    onChange={(e) => {
                                      setTaskAddData({
                                        ...taskAddData,
                                        email: e.target.value,
                                      });
                                    }}
                                    name={`email`}
                                    placeholder={t("email")}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("contact_type")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <Select
                                    className="my-Select"
                                    options={contactTypeList}
                                    value={contactTypeList.find(
                                      (option) =>
                                        option.value ===
                                        Number(taskAddData.contact_type_id)
                                    )}
                                    onChange={(selectedOption) =>
                                      setTaskAddData({
                                        ...taskAddData,
                                        contact_type_id: selectedOption.value,
                                      })
                                    }
                                    placeholder={"Select Contact type"}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("customer_notes")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <textarea
                                    className="form-control input-search"
                                    type="text"
                                    value={taskAddData.customer_notes}
                                    onChange={(e) => {
                                      setTaskAddData({
                                        ...taskAddData,
                                        customer_notes: e.target.value,
                                      });
                                    }}
                                    name={`customer_notes`}
                                    placeholder={t("customer_notes")}
                                    rows={3}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                        </div>
                      </>
                    )}

                    <div className="row">
                      <div className="col-md-6">
                        <FormGroup>
                          <Label className="col-form-label ml-2 Label-my form-label form-label">
                            {t("open_for_all_user")}
                          </Label>
                          <div className="col-xl-12">
                            <div className="input-div">
                              <div className="form-check">
                                <input
                                  className="my-checkbox-1 form-check-input"
                                  type="checkbox"
                                  checked={
                                    taskAddData.open_for_all_user === "1"
                                  }
                                  onChange={handleCheckboxOpenChange}
                                />
                                <label className="form-check-label pl-2">
                                  {t("open_for_all_user")}
                                </label>
                              </div>
                            </div>
                          </div>
                        </FormGroup>
                      </div>

                      <div className="col-md-6"></div>
                    </div>

                    {taskAddData.open_for_all_user === "0" && (
                      <>
                        <div className="row">
                          <div className="col-md-6">
                            <div
                              className="vehicleThBg"
                              style={{
                                height: "265px",
                                maxHeight: "300px",
                                overflow: "auto",
                                overflowY: "auto !important",
                              }}
                            >
                              <table className="rounded-table table table-striped table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th style={{ width: "10%" }}>
                                      {t("user")}
                                    </th>

                                    <th style={{ width: "10%" }}>
                                      {t("action")}
                                    </th>
                                  </tr>
                                </thead>
                                {userDataList &&
                                userDataList.filter(
                                  (v) =>
                                    !selectedUser.some(
                                      (item) => Number(item.user_id) === v.id
                                    )
                                ).length > 0 ? (
                                  userDataList
                                    .filter(
                                      (v) =>
                                        !selectedUser.some(
                                          (item) =>
                                            Number(item.user_id) === v.id
                                        )
                                    )
                                    .map((item, index) => (
                                      <tr key={index}>
                                        <td>{item.name}</td>
                                        <td>
                                          <Button
                                            className="addBtn"
                                            onClick={() => handleAddUser(item)}
                                            style={{
                                              backgroundColor: "green",
                                              color: "white",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <i className="bi bi-plus-lg"></i>
                                          </Button>
                                        </td>
                                      </tr>
                                    ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={2}
                                      style={{
                                        textAlign: "center",
                                        padding: "10px",
                                      }}
                                    >
                                      {t("no_record_found")}{" "}
                                    </td>
                                  </tr>
                                )}
                              </table>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="vehicleThBg table-responsive">
                              <table className="rounded-table table table-striped table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th style={{ width: "10%" }}>
                                      {t("user")}
                                    </th>

                                    <th style={{ width: "10%" }}>
                                      {t("action")}
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {selectedUser?.length > 0 ? (
                                    selectedUser?.map((item, index) => (
                                      <tr key={index}>
                                        <td>{item.name}</td>
                                        <td>
                                          <button
                                            className="btn-danger-delete"
                                            type="button"
                                            onClick={() =>
                                              handleRemoveUser(item)
                                            }
                                          >
                                            <i className="bi bi-trash3"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="100%">
                                        {t("no_user_selected")}
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {taskAddData?.task_type === 2 && (
                      <section className="content">
                        <div className="row">
                          <div className="card fuelCard">
                            <div className="card-header">
                              <div className="card-title m-0 float-right rightBtn">
                                <div
                                  className="row"
                                  style={{ marginTop: "10px" }}
                                >
                                  <div className="col-md-2">
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={filterData.internal_id}
                                      onChange={(e) =>
                                        setFilterData({
                                          ...filterData,
                                          internal_id: e.target.value,
                                        })
                                      }
                                      placeholder={t("internal_id")}
                                    ></input>
                                  </div>
                                  <div
                                    className="col-md-2"
                                    style={{
                                      width: "272px",
                                    }}
                                  >
                                    <Select
                                      className="my-select-v"
                                      options={VehicleTypeList}
                                      value={
                                        VehicleTypeList.find(
                                          (option) =>
                                            option.value ===
                                            filterData.vehicle_type
                                        ) || null
                                      }
                                      onChange={(selectedOption) =>
                                        setFilterData({
                                          ...filterData,
                                          vehicle_type: selectedOption
                                            ? selectedOption.value
                                            : "",
                                        })
                                      }
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Vehicle Types"}
                                    />
                                  </div>

                                  <div
                                    className="col-md-2"
                                    style={{
                                      width: "272px",
                                    }}
                                  >
                                    <Select
                                      className="my-select-v"
                                      options={VehicleYearList}
                                      value={VehicleYearList.find(
                                        (item) =>
                                          item.value == filterData.vehicle_year
                                      )}
                                      onChange={(selectedOption) => {
                                        setFilterData((prev) => ({
                                          ...prev,
                                          vehicle_year: selectedOption
                                            ? selectedOption.value
                                            : "",
                                          make_id: "",
                                          vehicle_vehicle_model_id: "",
                                          variants_id: "",
                                        }));
                                        setVehicleMakeList([]);
                                        setVehicleModalList([]);
                                        setVehicleVariantList([]);
                                      }}
                                      placeholder={"Year"}
                                      isClearable={true}
                                      onInputChange={
                                        handleInputSelectedChangeYearList
                                      }
                                      inputSelctedValue={inputSelctedeYearValue}
                                    />
                                  </div>

                                  <div
                                    className="col-md-2"
                                    style={{
                                      width: "272px",
                                    }}
                                  >
                                    <Select
                                      className="my-select-v"
                                      options={VehicleMakeList}
                                      value={
                                        VehicleMakeList.find(
                                          (item) =>
                                            item.value == filterData.make_id
                                        ) || null
                                      }
                                      onChange={(selectedOption) => {
                                        setFilterData((prev) => ({
                                          ...prev,
                                          make_id: selectedOption
                                            ? selectedOption.value
                                            : "",
                                          vehicle_vehicle_model_id: "",
                                          variants_id: "",
                                        }));

                                        setVehicleModalList([]);
                                        setVehicleVariantList([]);
                                      }}
                                      isSearchable={true}
                                      onInputChange={
                                        handleInputSelectedChangeMakeList
                                      }
                                      inputSelctedValue={inputSelctedeMakeValue}
                                      isClearable={true}
                                      placeholder={"Make"}
                                    />
                                  </div>

                                  <div
                                    className="col-md-2"
                                    style={{
                                      width: "272px",
                                    }}
                                  >
                                    <Select
                                      className="my-select-v"
                                      options={VehicleModalList}
                                      value={
                                        VehicleModalList.find(
                                          (item) =>
                                            item.value ==
                                            filterData.vehicle_model_id
                                        ) || null
                                      }
                                      onChange={(selectedOption) => {
                                        setFilterData((prev) => ({
                                          ...prev,
                                          vehicle_model_id: selectedOption
                                            ? selectedOption.value
                                            : "",
                                          variants_id: "",
                                        }));

                                        setVehicleVariantList([]);
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      onInputChange={
                                        handleInputSelectedChangeModalList
                                      }
                                      inputSelctedValue={
                                        inputSelctedeModalValue
                                      }
                                      placeholder={"Modal"}
                                    />
                                  </div>

                                  <div
                                    className="col-md-2"
                                    style={{
                                      width: "272px",
                                    }}
                                  >
                                    <Select
                                      className="my-select-v"
                                      options={VehicleVariantList}
                                      value={
                                        VehicleVariantList.find(
                                          (item) =>
                                            item.value == filterData.variants_id
                                        ) || null
                                      }
                                      onChange={(selectedOption) =>
                                        setFilterData({
                                          ...filterData,
                                          variants_id: selectedOption
                                            ? selectedOption.value
                                            : "",
                                        })
                                      }
                                      isSearchable={true}
                                      isClearable={true}
                                      onInputChange={
                                        handleInputSelectedChangeVariantList
                                      }
                                      inputSelctedValue={
                                        inputSelctededVariantValue
                                      }
                                      placeholder={"Variant"}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="card-body">
                              <div className="col-md-12">
                                <div className="vehicleThBg table-responsive">
                                  <table className="rounded-table table table-striped table-bordered table-hover">
                                    <thead>
                                      <tr>
                                        <th style={{ width: "10%" }}>
                                          {t("vehicle")}
                                        </th>
                                        <th style={{ width: "10%" }}>
                                          {t("tasks_details_notes")}
                                        </th>
                                        <th style={{ width: "10%" }}>
                                          {t("action")}
                                        </th>
                                      </tr>
                                    </thead>
                                    {vehicleModelAllList
                                      ?.filter(
                                        (v) =>
                                          !selectedVehicle?.some(
                                            (item) =>
                                              Number(item.vehicle_id) === v.id
                                          )
                                      )
                                      ?.map((item, index) => (
                                        <tr key={index}>
                                          <td>
                                            {`${item.vehicle_year || ""} | ${
                                              item.vehicle_make_name || ""
                                            } | ${item.vehicle_model || ""} | ${
                                              item.vehicle_variant_name || ""
                                            } | ${
                                              item.vehicle_internal_id || ""
                                            }`}
                                          </td>
                                          <td>
                                            <FormGroup>
                                              <Label>{t("task_note")}</Label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                  vehicleNote[item?.id] || ""
                                                }
                                                onChange={(e) =>
                                                  setVehicleNote({
                                                    ...vehicleNote,
                                                    [item?.id]: e.target.value,
                                                  })
                                                }
                                                placeholder={t("enter_task_note")}
                                              />
                                            </FormGroup>
                                          </td>
                                          <td>
                                            <Button
                                              className="addBtn"
                                              onClick={() =>
                                                handleAddVehicle(
                                                  item,
                                                  vehicleNote[item.id] || ""
                                                )
                                              }
                                              style={{
                                                backgroundColor: "green",
                                                color: "white",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <i className="bi bi-plus-lg"></i>
                                            </Button>
                                          </td>
                                        </tr>
                                      ))}
                                  </table>
                                </div>
                              </div>
                              <div
                                className="col-md-12"
                                style={{
                                  marginTop: "60px",
                                }}
                              >
                                <div className="vehicleThBg table-responsive">
                                  <table className="rounded-table table table-striped table-bordered table-hover">
                                    <thead>
                                      <tr>
                                        <th style={{ width: "10%" }}>
                                          {t("vehicle")}
                                        </th>
                                        <th style={{ width: "10%" }}>
                                          {t("tasks_details_notes")}
                                        </th>
                                        <th style={{ width: "10%" }}>
                                          {t("action")}
                                        </th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {selectedVehicle?.length > 0 ? (
                                        selectedVehicle.map((item, index) => (
                                          <tr key={index}>
                                            <td>{item.vehicle_name}</td>
                                            <td>
                                              {uuid ? (
                                                <>
                                                  <FormGroup>
                                                    <Label>
                                                      {t("task_note")}
                                                    </Label>
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      value={
                                                        vehicleNote[item.id] ??
                                                        item.tasks_details_notes ??
                                                        ""
                                                      }
                                                      onChange={(e) =>
                                                        setVehicleNote({
                                                          ...vehicleNote,
                                                          [item.id]:
                                                            e.target.value,
                                                        })
                                                      }
                                                      placeholder={t("enter_task_note")}
                                                    />
                                                  </FormGroup>
                                                </>
                                              ) : (
                                                <span>
                                                  {item.tasks_details_notes}
                                                </span>
                                              )}
                                            </td>

                                            <td>
                                              <button
                                                className="btn-danger-delete"
                                                type="button"
                                                onClick={() =>
                                                  handleAddVehicle(
                                                    { id: item.vehicle_id },
                                                    ""
                                                  )
                                                }
                                              >
                                                <i className="bi bi-trash3"></i>
                                              </button>
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan="100%">
                                            {t("no_vehicle_selected")}
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    )}

                    {taskAddData?.task_type === 1 && (
                      <section className="content">
                        <div className="row">
                          <div className="card fuelCard">
                            <div className="card-header">
                              <div
                                className="card-title m-0 float-left"
                                style={{ width: "30%" }}
                              >
                                <div className="row">
                                  <div className="col-md-6">
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={filterPartData.search}
                                      onChange={(e) =>
                                        setFilterPartData({
                                          ...filterPartData,
                                          search: e.target.value,
                                        })
                                      }
                                      placeholder={t("search")}
                                    ></input>
                                  </div>

                                  <div className="col-md-6">
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={filterPartData.internal_id}
                                      onChange={(e) =>
                                        setFilterPartData({
                                          ...filterPartData,
                                          internal_id: e.target.value,
                                        })
                                      }
                                      placeholder={t("internal_id")}
                                    ></input>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="card-body">
                              <div className="col-md-12">
                                <div
                                  className="vehicleThBg"
                                  style={{
                                    height: "265px",
                                    maxHeight: "300px",
                                    overflow: "auto",
                                    overflowY: "auto !important",
                                  }}
                                >
                                  <table className="rounded-table table table-striped table-bordered table-hover">
                                    <thead>
                                      <tr>
                                        <th style={{ width: "10%" }}>
                                          {t("part")}
                                        </th>

                                        <th style={{ width: "10%" }}>
                                          {t("action")}
                                        </th>
                                      </tr>
                                    </thead>
                                    {partModelAllList
                                      ?.filter(
                                        (v) =>
                                          !taskAddData.part_list.some(
                                            (item) => item.id === v.id
                                          )
                                      )
                                      ?.map((item, index) => (
                                        <tr key={index}>
                                          <td>
                                            {`${item.namePartPT || ""} | ${
                                              item.vehicle_year || ""
                                            } | ${
                                              item.vehicle_make_name || ""
                                            } | ${item.vehicle_model || ""} | ${
                                              item.vehicle_variant_name || ""
                                            } | ${
                                              item.parts_internal_id || ""
                                            }`}
                                          </td>

                                          <td>
                                            <Button
                                              className="addBtn"
                                              onClick={() =>
                                                handleAddPart(item)
                                              }
                                              style={{
                                                backgroundColor: "green",
                                                color: "white",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <i className="bi bi-plus-lg"></i>
                                            </Button>
                                          </td>
                                        </tr>
                                      ))}
                                  </table>
                                </div>
                              </div>
                              <div
                                className="col-md-12"
                                style={{
                                  marginTop: "60px",
                                }}
                              >
                                <div className="vehicleThBg table-responsive">
                                  <table className="rounded-table table table-striped table-bordered table-hover">
                                    <thead>
                                      <tr>
                                        <th style={{ width: "10%" }}>
                                          {t("part")}
                                        </th>
                                        <th style={{ width: "10%" }}>
                                          {t("asssign_quantity")}
                                        </th>

                                        <th style={{ width: "10%" }}>
                                          {t("action")}
                                        </th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {taskAddData?.part_list?.length > 0 ? (
                                        taskAddData?.part_list?.map(
                                          (item, index) => (
                                            <tr key={index}>
                                              <td>{item.part_name}</td>

                                              <td
                                                style={{ cursor: "pointer" }}
                                                onClick={(e) =>
                                                  handleQtyOpen(e, item)
                                                }
                                              >
                                                <i className="bi bi-clipboard-check"></i>
                                              </td>
                                              <td>
                                                <button
                                                  className="btn-danger-delete"
                                                  type="button"
                                                  onClick={() =>
                                                    handleAddPart(
                                                      { id: item.id },
                                                      ""
                                                    )
                                                  }
                                                >
                                                  <i className="bi bi-trash3"></i>
                                                </button>
                                              </td>
                                            </tr>
                                          )
                                        )
                                      ) : (
                                        <tr>
                                          <td colSpan="100%">
                                            {t("no_vehicle_selected")}
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    )}

                    {taskDetails?.id && (
                      <div className="row">
                        <div className="col-md-6">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("task_satus")}{" "}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  options={taskStatusList}
                                  value={taskStatusList.find(
                                    (option) =>
                                      option.value ===
                                      Number(taskAddData.tasks_status)
                                  )}
                                  onChange={(selectedOption) =>
                                    setTaskAddData({
                                      ...taskAddData,
                                      tasks_status: selectedOption.value,
                                    })
                                  }
                                  placeholder={"Select Contact type"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>
                        <div className="col-md-6"></div>
                      </div>
                    )}
                  </div>

                  <div className="card-footer back-footer card-footer-task">
                    <div className="row">
                      <div className="col ms-2">
                        <button
                          type="button"
                          className="back-btn"
                          onClick={() => navigate("/tasks")}
                        >
                          <i className="bi bi-arrow-left"> </i> {t("back")}
                        </button>
                      </div>
                      <div className="col">
                        <div className="d-flex justify-content-end nxt-btn position-relative">
                          <div
                            className={`chatbox ${
                              isOpen ? "active" : "inactive"
                            }`}
                          >
                            {isOpen && (
                              <div className="chatbox-support">
                                <div className="chatbox-header">
                                  <div className="chatbox-image-header"></div>
                                  <div className="chatbox-content-header">
                                    <h4 className="chatbox-heading-header">
                                      Chat support
                                    </h4>
                                    <p
                                      className="chatbox-description-header"
                                      style={{ display: "none" }}
                                    >
                                      There are many variations of passages of
                                      Lorem Ipsum available
                                    </p>
                                  </div>
                                </div>

                                <div
                                  className="chatbox-messages"
                                  style={{
                                    overflowY: "auto",
                                    maxHeight: "400px",
                                  }}
                                >
                                  {sortedMessagesAsc?.map((msg, index) => {
                                    const chatId = msg.chat_id ?? msg.id;
                                    const isSelected =
                                      selectedChats.includes(chatId);
                                    const isCurrentUser =
                                      Number(msg.user_id) ===
                                      Number(companyId.id);

                                    return (
                                      <div
                                        key={chatId}
                                        className={`messages-item ${
                                          isCurrentUser
                                            ? "messages-item-current-user"
                                            : "messages-item-other-user"
                                        }`}
                                      >
                                        <div className="flex items-start gap-2">
                                          {taskAddData?.is_customer_support ===
                                            "1" && (
                                            <input
                                              type="checkbox"
                                              checked={isSelected}
                                              onChange={(e) => {
                                                if (e.target.checked) {
                                                  setSelectedChats((prev) => [
                                                    ...prev,
                                                    chatId,
                                                  ]);
                                                } else {
                                                  setSelectedChats((prev) =>
                                                    prev.filter(
                                                      (id) => id !== chatId
                                                    )
                                                  );
                                                }
                                              }}
                                            />
                                          )}
                                          <div className="flex-1">
                                            <div className="message-meta text-xs text-gray-500 mb-1">
                                              <span className="font-semibold">
                                                {msg.name}
                                              </span>{" "}
                                              · <span>{msg.created_at}</span>
                                            </div>
                                            {msg.message && (
                                              <div>{msg.message}</div>
                                            )}
                                            {msg.attach_url && (
                                              <div className="mt-1">
                                                <a
                                                  href={msg.attach_url}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  className="text-blue-600 underline text-sm flex items-center gap-1"
                                                >
                                                  <i className="bi bi-paperclip"></i>{" "}
                                                  Download Attachment
                                                </a>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}

                                  <div ref={chatEndRef} />
                                </div>

                                <div className="chatbox-footer">
                                  <i
                                    className="bi bi-arrow-clockwise"
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "24px",
                                    }}
                                    onClick={fetchChatMessages}
                                    title="Refresh Chat"
                                  ></i>{" "}
                                  <input
                                    type="text"
                                    placeholder={t("write_a_message")}
                                    className="flex-1 px-3 py-1 border rounded-md"
                                    value={input}
                                    onChange={(e) => setInput(e.target.value)}
                                    onKeyDown={(e) =>
                                      e.key === "Enter" && sendMessage()
                                    }
                                  />
                                  <p
                                    className="chatbox-send-footer"
                                    onClick={
                                      input ? handleSubmitChatTask : null
                                    }
                                    style={{
                                      cursor: input ? "pointer" : "not-allowed",
                                      opacity: input ? 1 : 0.5,
                                      pointerEvents: input ? "auto" : "none",
                                    }}
                                  >
                                    Send
                                  </p>
                                  <input
                                    type="file"
                                    ref={fileInputRef}
                                    onChange={handleFileChange}
                                    style={{ display: "none" }}
                                    accept="image/*,application/pdf"
                                  />
                                  <i
                                    className="bi bi-paperclip w-5 h-5"
                                    style={{ cursor: "pointer" }}
                                    onClick={handleFileClick}
                                  ></i>
                                  {taskAddData?.is_customer_support === "1" && (
                                    <p
                                      className="chatbox-send-footer"
                                      onClick={
                                        !isSending
                                          ? handleSendCustomerMessageWp
                                          : null
                                      }
                                      style={{
                                        cursor: isSending
                                          ? "not-allowed"
                                          : "pointer",
                                        opacity: isSending ? 0.6 : 1,
                                      }}
                                    >
                                      {isSending ? (
                                        <span
                                          className="spinner-border spinner-border-sm"
                                          role="status"
                                        />
                                      ) : (
                                        <i className="bi bi-whatsapp"></i>
                                      )}
                                    </p>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>

                          {uuid && (
                            <div>
                              <button
                                onClick={toggleChat}
                                className={`btn chatbox-button mx-2 ${
                                  isOpen ? "active" : "inactive"
                                }`}
                                type="button"
                              >
                                <i
                                  className={`bi ${
                                    isOpen ? "bi-x" : "bi bi-chat-dots"
                                  }`}
                                ></i>
                              </button>
                            </div>
                          )}

                          {btnLoader === true ? (
                            <button type="submit" className="btn btn-primary">
                              Loading...
                            </button>
                          ) : (
                            <button type="submit" className="btn btn-primary">
                              {t("submit")} <i className="bi bi-check2"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>

        <Modal isOpen={modifyModal} size="lg">
          <ModalHeader>Client Profile</ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Name"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.name}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            name: e.target.value,
                          });
                        }}
                        name={`name`}
                        maxLength={50}
                        placeholder={t("name")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Country Code"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.country_code}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            country_code: e.target.value,
                          });
                        }}
                        name={`country_code`}
                        maxLength={50}
                        placeholder={t("country_code")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("country")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={countryList}
                        value={countryList.find(
                          (option) =>
                            option.value ===
                            Number(clientProfileData.country_id)
                        )}
                        onChange={(selectedOption) =>
                          setclientProfileData({
                            ...clientProfileData,
                            country_id: selectedOption.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"State"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={stateList}
                        value={stateList.find(
                          (option) =>
                            option.value === Number(clientProfileData.district)
                        )}
                        onChange={(selectedOption) =>
                          setclientProfileData({
                            ...clientProfileData,
                            district: selectedOption.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("city")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={cityList}
                        value={cityList.find(
                          (option) =>
                            option.value === Number(clientProfileData.city)
                        )}
                        onChange={(selectedOption) => {
                          setclientProfileData({
                            ...clientProfileData,
                            city: selectedOption.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Bill Address"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.bill_address}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            bill_address: e.target.value,
                          });
                        }}
                        name={`bill_address`}
                        maxLength={50}
                        placeholder={t("bill_address")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Postal code"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.postal_code}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            postal_code: e.target.value,
                          });
                        }}
                        name={`postal_code`}
                        maxLength={50}
                        placeholder={t("postal_code")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"VAT country code"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.vat_country_code}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            vat_country_code: e.target.value,
                          });
                        }}
                        name={`vat_country_code`}
                        maxLength={50}
                        placeholder={t("vat_country_code")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"VAT number"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.vat_number}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            vat_number: e.target.value,
                          });
                        }}
                        name={`vat_number`}
                        maxLength={50}
                        placeholder={t("vat_number")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"VAT Percentages(%)"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.vat_percentage ?? 23}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            vat_percentage: e.target.value,
                          });
                        }}
                        name="vat_percentage"
                        maxLength={50}
                        placeholder={t("vat_percentages")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    Is VAT exempt{" "}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={clientProfileData?.is_vat_exempt === "1"}
                          onChange={handleCheckboxClientVatChange}
                        />
                        <label className="form-check-label">VAT exempt </label>
                      </div>
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Indicative phone code"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={
                          clientProfileData.indicative_phone_code || "+351"
                        }
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            indicative_phone_code: e.target.value,
                          });
                        }}
                        name={`indicative_phone_code`}
                        maxLength={50}
                        placeholder={t("indicative_phone_code")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Phone Number"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.phone_number}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            phone_number: e.target.value,
                          });
                        }}
                        name={`phone_number`}
                        maxLength={50}
                        placeholder={t("phone_number")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Whatsapp Number"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.whatsapp_number}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            whatsapp_number: e.target.value,
                          });
                        }}
                        name={`whatsapp_number`}
                        maxLength={50}
                        placeholder={t("whatsapp_number")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Email"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.email}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            email: e.target.value,
                          });
                        }}
                        name={`email`}
                        maxLength={50}
                        placeholder={t("email")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4"></div>

              <div className="col-md-12">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    Shipping Address
                  </Label>
                  <div className="col-xl-12">
                    {clientProfileData?.shipping_addresses?.map(
                      (address, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center mb-2"
                        >
                          <input
                            type="text"
                            className="form-control input-search mr-2"
                            placeholder={`Shipping address ${index + 1}`}
                            value={address}
                            onChange={(e) =>
                              handleAddressChange(index, e.target.value)
                            } // Update address
                          />
                          <i
                            className="bi bi-x-circle"
                            style={{
                              marginTop: "-41px",
                              marginLeft: "-16px",
                              color: "red",
                              cursor: "pointer",
                            }}
                            onClick={() => handleRemoveAddress(index)} // Remove address
                          ></i>
                        </div>
                      )
                    )}

                    <button
                      type="button"
                      className="btn btn-primary btn-sm mt-2"
                      onClick={handleAddAddress} // Add address
                    >
                      ➕ Add Address
                    </button>
                  </div>
                </FormGroup>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              disabled={isModifyButtonLoad}
              onClick={handleCloseModal}
              style={{ width: "100px", marginTop: "10px" }}
            >{t("close")}<i className="bi bi-x-lg"></i>
            </button>
            {!isModifyButtonLoad && (
              <button
                type="button"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
                onClick={handleSaveDataModal}
              >{t("save")}<i className="bi bi-check2"></i>
              </button>
            )}

            {isModifyButtonLoad && (
              <Button
                color="success"
                type={`button`}
                disabled={true}
                className={`btn-square`}
              >
                <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
              </Button>
            )}
          </ModalFooter>
        </Modal>

        <Modal isOpen={modifyAddClientModal} size="lg">
          <ModalHeader>Client Profile</ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Name"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientAddProfileData.name}
                        onChange={(e) => {
                          setClientAddProfileData({
                            ...clientAddProfileData,
                            name: e.target.value,
                          });
                        }}
                        name={`name`}
                        maxLength={50}
                        placeholder={t("name")}
                      />
                      {errors.name && (
                        <span className="input-error">{errors.name}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Country Code"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientAddProfileData.country_code}
                        onChange={(e) => {
                          setClientAddProfileData({
                            ...clientAddProfileData,
                            country_code: e.target.value,
                          });
                        }}
                        name={`country_code`}
                        maxLength={50}
                        placeholder={t("country_code")}
                      />
                      {errors.country_code && (
                        <span className="input-error">
                          {errors.country_code}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("country")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={countryList}
                        value={countryList.find(
                          (option) =>
                            option.value ===
                            Number(clientAddProfileData.country_id)
                        )}
                        onChange={(selectedOption) =>
                          setClientAddProfileData({
                            ...clientAddProfileData,
                            country_id: selectedOption.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"State"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={stateMainList}
                        value={stateMainList.find(
                          (option) =>
                            option.value ===
                            Number(clientAddProfileData.district)
                        )}
                        onChange={(selectedOption) =>
                          setClientAddProfileData({
                            ...clientAddProfileData,
                            district: selectedOption.value,
                          })
                        }
                      />
                      {errors.district && (
                        <span className="input-error">{errors.district}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("city")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={cityMainList}
                        value={cityMainList.find(
                          (option) =>
                            option.value === Number(clientAddProfileData.city)
                        )}
                        onChange={(selectedOption) => {
                          setClientAddProfileData({
                            ...clientAddProfileData,
                            city: selectedOption.value,
                          });
                        }}
                      />
                      {errors.city && (
                        <span className="input-error">{errors.city}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Bill Address"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientAddProfileData.bill_address}
                        onChange={(e) => {
                          setClientAddProfileData({
                            ...clientAddProfileData,
                            bill_address: e.target.value,
                          });
                        }}
                        name={`bill_address`}
                        maxLength={50}
                        placeholder={t("bill_address")}
                      />
                      {errors.bill_address && (
                        <span className="input-error">
                          {errors.bill_address}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Postal code"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientAddProfileData.postal_code}
                        onChange={(e) => {
                          setClientAddProfileData({
                            ...clientAddProfileData,
                            postal_code: e.target.value,
                          });
                        }}
                        name={`postal_code`}
                        maxLength={50}
                        placeholder={t("postal_code")}
                      />

                      {errors.postal_code && (
                        <span className="input-error">
                          {errors.postal_code}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"VAT country code"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientAddProfileData.vat_country_code}
                        onChange={(e) => {
                          setClientAddProfileData({
                            ...clientAddProfileData,
                            vat_country_code: e.target.value,
                          });
                        }}
                        name={`vat_country_code`}
                        maxLength={50}
                        placeholder={t("vat_country_code")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"VAT number"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientAddProfileData.vat_number}
                        onChange={(e) => {
                          setClientAddProfileData({
                            ...clientAddProfileData,
                            vat_number: e.target.value,
                          });
                        }}
                        name={`vat_number`}
                        maxLength={50}
                        placeholder={t("vat_number")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"VAT Percentages(%)"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientAddProfileData.vat_percentage ?? 23}
                        onChange={(e) => {
                          setClientAddProfileData({
                            ...clientAddProfileData,
                            vat_percentage: e.target.value,
                          });
                        }}
                        name="vat_percentage"
                        maxLength={50}
                        placeholder={t("vat_percentages")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    Is VAT exempt{" "}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={clientAddProfileData?.is_vat_exempt === "1"}
                          onChange={handleCheckboxAddClientVatChange}
                        />
                        <label className="form-check-label">VAT exempt </label>
                      </div>
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Indicative phone code"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={
                          clientAddProfileData.indicative_phone_code || "+351"
                        }
                        onChange={(e) => {
                          setClientAddProfileData({
                            ...clientAddProfileData,
                            indicative_phone_code: e.target.value,
                          });
                        }}
                        name={`indicative_phone_code`}
                        maxLength={50}
                        placeholder={t("indicative_phone_code")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Phone Number"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientAddProfileData.phone_number}
                        onChange={(e) => {
                          setClientAddProfileData({
                            ...clientAddProfileData,
                            phone_number: e.target.value,
                          });
                        }}
                        name={`phone_number`}
                        maxLength={50}
                        placeholder={t("phone_number")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Whatsapp Number"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientAddProfileData.whatsapp_number}
                        onChange={(e) => {
                          setClientAddProfileData({
                            ...clientAddProfileData,
                            whatsapp_number: e.target.value,
                          });
                        }}
                        name={`whatsapp_number`}
                        maxLength={50}
                        placeholder={t("whatsapp_number")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Email"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientAddProfileData.email}
                        onChange={(e) => {
                          setClientAddProfileData({
                            ...clientAddProfileData,
                            email: e.target.value,
                          });
                        }}
                        name={`email`}
                        maxLength={50}
                        placeholder={t("email")}
                      />
                      {errors.email && (
                        <span className="input-error">{errors.email}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4"></div>

              <div className="col-md-12">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    Shipping Address
                  </Label>
                  <div className="col-xl-12">
                    {clientAddProfileData?.shipping_addresses?.map(
                      (address, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center mb-2"
                        >
                          <input
                            type="text"
                            className="form-control input-search mr-2"
                            placeholder={`Shipping address ${index + 1}`}
                            value={address}
                            onChange={(e) =>
                              handleAddressChangeMainClient(
                                index,
                                e.target.value
                              )
                            } // Update address
                          />
                          <i
                            className="bi bi-x-circle"
                            style={{
                              marginTop: "-41px",
                              marginLeft: "-16px",
                              color: "red",
                              cursor: "pointer",
                            }}
                            onClick={() => handleRemoveAddressMainClient(index)} // Remove address
                          ></i>
                        </div>
                      )
                    )}

                    <button
                      type="button"
                      className="btn btn-primary btn-sm mt-2"
                      onClick={handleAddAddressMainClient}
                    >
                      ➕ Add Address
                    </button>
                  </div>
                </FormGroup>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleCloseAddClientModal}
              style={{ width: "100px", marginTop: "10px" }}
            >{t("close")}<i className="bi bi-x-lg"></i>
            </button>

            <button
              type="button"
              className="btn btn-block btn-primary"
              style={{ width: "125px", marginTop: "10px" }}
              onClick={handleAddClient}
            >
              Add Client <i className="bi bi-check2"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={modifyqtyModal} size="xl">
          <ModalHeader>{`Quantity`}</ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div
                  className="row"
                  style={{
                    overflowX: "auto",
                    maxHeight: "300px",
                  }}
                >
                  <div className="card-body">
                    <div className="vehicleThBg table-responsive table-responsive-vehicle">
                      <table className="table table-bordered rounded-table table table-striped table-hover">
                        <thead>
                          <tr>
                            <th
                              className="col-form-label ml-2 Label-my form-label"
                              style={{ width: "10%" }}
                            ></th>
                            <th
                              className="col-form-label ml-2 Label-my form-label"
                              style={{ width: "10%" }}
                            >
                              Quantity
                            </th>

                            <th
                              className="col-form-label ml-2 Label-my form-label"
                              style={{ width: "10%" }}
                            >
                              Entity
                            </th>
                            <th
                              className="col-form-label ml-2 Label-my form-label"
                              style={{ width: "10%" }}
                            >
                              Price
                            </th>

                            <th
                              className="col-form-label ml-2 Label-my form-label"
                              style={{ width: "10%" }}
                            >
                              Notes
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {partqtyDetails?.part_qty_list?.length > 0 ? (
                            partqtyDetails?.part_qty_list?.map(
                              (part, index) => {
                                return (
                                  <>
                                    <tr
                                      style={{ cursor: "pointer" }}
                                      key={index}
                                    >
                                      <td>
                                        <input
                                          type="checkbox"
                                          className="my-checkbox-1 form-check-input"
                                          checked={selectedParts?.some(
                                            (item) => item.id === part.id
                                          )}
                                          onChange={() =>
                                            handleCheckboxChangeTask(
                                              part.parts_id,
                                              part.id
                                            )
                                          }
                                          style={{ marginLeft: "100px" }}
                                        />
                                      </td>
                                      <td>{part.qty}</td>

                                      <td>
                                        <select
                                          className="form-select"
                                          value={
                                            selectedEntities[part.id] ||
                                            part.location_ids ||
                                            ""
                                          }
                                          onChange={(e) =>
                                            handleSelectChange(e, part)
                                          }
                                        >
                                          <option value="" disabled>
                                            Select
                                          </option>
                                          {renderOptions(entityList)}
                                        </select>
                                      </td>
                                      <td>
                                        <div>
                                          <label>
                                            Price 1:{" "}
                                            {partqtyDetails?.part?.part_price
                                              ? partqtyDetails?.part?.part_price
                                              : partqtyDetails?.part_price}
                                          </label>
                                        </div>

                                        <div>
                                          <label>
                                            Price 2:{" "}
                                            {partqtyDetails?.part
                                              ?.part_original_price
                                              ? partqtyDetails?.part
                                                  ?.part_original_price
                                              : partqtyDetails?.part_original_price}
                                          </label>
                                        </div>

                                        <div>
                                          <label>
                                            Price 2:{" "}
                                            {partqtyDetails?.part
                                              ?.part_cost_price
                                              ? partqtyDetails?.part
                                                  ?.part_cost_price
                                              : partqtyDetails?.part_cost_price}
                                          </label>
                                        </div>

                                        <div>
                                          <label>
                                            Manual:
                                            <input
                                              type="number"
                                              value={
                                                selectedPrices[part.id] || ""
                                              }
                                              onChange={(e) =>
                                                handleManualInput(
                                                  part.id,
                                                  e.target.value
                                                )
                                              }
                                              placeholder={t("enter_manual_price")}
                                              style={{
                                                marginLeft: "10px",
                                                width: "100px",
                                              }}
                                            />
                                          </label>
                                        </div>
                                      </td>

                                      <td>
                                        <div className="input-div">
                                          <textarea
                                            className="form-control"
                                            value={
                                              resOrderData
                                                .reservation_order_notes[
                                                part.id
                                              ] || ""
                                            }
                                            onChange={(e) =>
                                              setResOrderData((prev) => ({
                                                ...prev,
                                                reservation_order_notes: {
                                                  ...prev.reservation_order_notes,
                                                  [part.id]: e.target.value,
                                                },
                                              }))
                                            }
                                            name={`reservation_order_notes_${part.id}`}
                                            placeholder={t("notes")}
                                            rows={3}
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                  </>
                                );
                              }
                            )
                          ) : (
                            <tr>
                              <td colSpan="5" style={{ textAlign: "center" }}>
                                No data found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleQtyClose}
              style={{ width: "100px", marginTop: "10px" }}
            >{t("close")}<i className="bi bi-x-lg"></i>
            </button>

            <button
              type="Button"
              className="btn btn-block btn-primary"
              onClick={handleQtyCloseFinal}
              style={{ width: "100px", marginTop: "10px" }}
            >{t("save")}<i className="bi bi-x-lg"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={delModal}>
          <ModalHeader>{`Delete User`}</ModalHeader>
          <ModalBody>
            <p
              className={`mb-0`}
            >{`Are you sure you want to delete this user?`}</p>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              disabled={isDelButtonLoad}
              onClick={onDeleteModalClose}
              style={{ width: "100px", marginTop: "10px" }}
            >{t("close")}<i className="bi bi-x-lg"></i>
            </button>

            {!isDelButtonLoad && (
              <button
                type="button"
                className="btn btn-block bg-red"
                style={{ width: "100px" }}
                onClick={onDestoryMainTask}
              >{t("delete")}<i className="bi bi-trash3"></i>
              </button>
            )}
            {isDelButtonLoad && (
              <button
                color="secondary"
                type={`button`}
                disabled={true}
                className={`btn-square`}
              >
                <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
              </button>
            )}
          </ModalFooter>
        </Modal>
      </section>
    </div>
  );
};

export default AddTask;
